// extracted by mini-css-extract-plugin
export default {"datePickerWrapper":"StyledDatePicker_datePickerWrapper__yW658"};